import React, { createContext, useContext, useState, useEffect, useCallback, useRef  } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import '../layout/Popups.Module.css'
import Modal from 'react-bootstrap/Modal';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const timeoutId = useRef(null);
  const warningTimeoutId = useRef(null); // Para gerenciar o tempo de aviso
  const [isLoggedOut, setIsLoggedOut] = useState(false);
  const [hasLoggedIn, setHasLoggedIn] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [message, setMessage] = useState(''); 
  const navigate = useNavigate();
  const location = useLocation();
  const [logoutMessage, setLogoutMessage] = useState('');
  const [logoutModalVisible, setLogoutModalVisible] = useState(false);

  const idleTimeout = 15 * 60 * 1000; // 15 minutos de inatividade
  const warningTimeout = 1 * 60 * 1000; // 1 minuto de aviso
    // Exibir aviso de logout próximo
  // Carregar usuário do localStorage ao iniciar
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const logoutReason = sessionStorage.getItem('logoutReason');
    if (storedUser) {
      setUser(JSON.parse(storedUser)); // Define o usuário a partir do localStorage
      setIsLoggedOut(false); // Garante que o usuário não esteja marcado como desconectado
    }

      // ⚠️ Exibe aviso persistente após logout automático
  if (logoutReason) {
    setLogoutMessage(logoutReason);
    setLogoutModalVisible(true);

    // Limpa o motivo após exibir
    sessionStorage.removeItem('logoutReason');
  }
  }, []);

  const closeLogoutModal = () => {
    setLogoutModalVisible(false); // Fecha o modal
  };
  
  const logout = useCallback(() => {
    if (user && !isLoggedOut) {
      setUser(null);
      setIsLoggedOut(true);
      localStorage.removeItem('user'); // Remove o usuário do localStorage
      setMessage('Você foi desconectado.');

      //sessionStorage.setItem('logoutReason', 'Você foi desconectado por inatividade.');
      setLogoutModalVisible(true);

      // Redireciona para a página principal apenas se estiver em /area-pessoal
      if (location.pathname === '/area-pessoal') {
        navigate('/'); // Redireciona para a página principal
      }
    }
    sessionStorage.removeItem('hasSeenPopup');
  }, [user, isLoggedOut, navigate, location.pathname]);

  // Função de login
  const login = async (userData) => {
    if (!userData || !userData.id) {
      console.error('Erro: ID do usuário não foi retornado pelo backend.', userData);
      return;
    }
  
    try {
      // Após o login, busque a lista de favoritos do backend
      //const favoritesResponse = await axios.get(`https://advancelighting.pt/get_favoritos.php?user_id=${userData.id}`);
      //userData.favorites = favoritesResponse.data.favoritos || []; // Atualiza favoritos do usuário
  
      // Atualiza o estado do usuário com os dados e favoritos
      setUser(userData);
      setIsLoggedOut(false); // Garante que o usuário não esteja marcado como desconectado
      setHasLoggedIn(true);
      localStorage.setItem('user', JSON.stringify(userData)); // Salva os dados no localStorage
      setMessage(''); // Limpa qualquer mensagem de notificação
    } catch (error) {
      console.error('Erro ao fazer login:', error);
      alert('Erro ao fazer login');
    }
  };

  {/*
     const resetTimers = useCallback(() => {
    if (timeoutId.current) clearTimeout(timeoutId.current);
    if (warningTimeoutId.current) clearTimeout(warningTimeoutId.current);
  
    setShowWarning(false);
    setLogoutMessage(''); 
  
    warningTimeoutId.current = setTimeout(() => {
      setShowWarning(true);
      setLogoutMessage('Você será desconectado automaticamente em 1 minuto por inatividade.');
  
      timeoutId.current = setTimeout(() => {
        setLogoutMessage('Você foi desconectado por inatividade.');
        logout();
      }, warningTimeout);
    }, idleTimeout - warningTimeout);
  }, [idleTimeout, warningTimeout, logout]);

  
     useEffect(() => {
    const handleActivity = () => resetTimers();
  
    window.addEventListener('mousemove', handleActivity);
    window.addEventListener('keydown', handleActivity);
  
    resetTimers();
  
    return () => {
      window.removeEventListener('mousemove', handleActivity);
      window.removeEventListener('keydown', handleActivity);
      if (timeoutId.current) clearTimeout(timeoutId.current);
      if (warningTimeoutId.current) clearTimeout(warningTimeoutId.current);
    };
  }, [resetTimers]); 
  */}

/*
  const toggleFavorite = async (product) => {
    console.log('Enviando dados para adicionar ou remover favorito:', {
      user_id: user.id,
      produto_id: product.idP,
    });
  
    const updatedFavorites = user.favorites || [];
    const isFavorite = user?.favorites?.some(fav => fav.idP == product.idP);
  
    try {
      let response;
      if (isFavorite) {
        // Se o produto já for favorito, remove da lista
        updatedFavorites.splice(updatedFavorites.findIndex(fav => fav.idP === product.idP), 1);
        response = await axios.post('https://advancelighting.pt/remover_favorito.php', {
          user_id: user.id,
          produto_id: product.idP,
        });
        console.log('Removendo favorito: user_id:', user.id, 'produto_id:', product.idP);
      } else {
        // Se o produto não for favorito, adiciona à lista
        updatedFavorites.push(product);
        response = await axios.post('https://advancelighting.pt/adicionar_favorito.php', {
          user_id: user.id,
          produto_id: product.idP,
        });
        console.log('Adicionando favorito: user_id:', user.id, 'produto_id:', product.idP);
      }
  
      if (response.data.success) {
        // Atualiza o estado de usuário com a nova lista de favoritos
        setUser(prevUser => {
          const updatedUser = { ...prevUser, favorites: updatedFavorites };
          localStorage.setItem('user', JSON.stringify(updatedUser)); // Atualiza o localStorage
          return updatedUser; // Retorna o usuário atualizado
        });
      } else {
        alert(response.data.message || 'Erro ao atualizar os favoritos.');
      }
    } catch (error) {
      console.error('Erro ao sincronizar favoritos com o backend:', error);
      alert('Erro ao sincronizar os favoritos. Tente novamente mais tarde.');
    }
};
*/

  return (
    <AuthContext.Provider value={{ user, login, logout, hasLoggedIn }}>
      {children}
      {message && <div className="notification">{message}</div>} {/* Exibe a mensagem de forma não bloqueante */}
      {logoutModalVisible  && (
        <div className="logout-modal">
          <p>{logoutMessage}</p>
          <button onClick={() => setLogoutModalVisible(false)}>OK</button>
        </div>
      )}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};